<script setup>
import {ref, onMounted} from 'vue'
import axios from 'axios'
import NeoRtc from '../../../../app/Modules/Chat/Resources/assets/js/neo-rtc'

const notifications = ref({
    data: []
})

const url = '/my-connect'
const axiosInstance = axios.create({
    baseURL: process.env.APP_URL
})

async function loadChatNotifications(){
    try {
        // append text into chat screen and set status waiting

        const response = await axiosInstance.get(`${url}/messages/get-unread-messages`)

        // broadcast to target to refresh loadChatGroup and loadGroup
        notifications.value.data = response.data.data

    } catch (error) {
        // show error icon and add click event to resend the message
        console.log(error)
    }
}

async function readAll(){
    try {
        // append text into chat screen and set status waiting

        await axiosInstance.post(`${url}/messages/read-all-messages`)
        notifications.value.data = []

    } catch (error) {
        // show error icon and add click event to resend the message
        console.log(error)
    }
}

function pushChatNotifications(notif){
    notifications.value.data = [notif, ...notifications.value.data]
}

onMounted( async e => {
    
    const userId = document.querySelector('.notif-chat-dropdown').dataset.neoid
    if(userId)
    {
        window.neoRtc = new NeoRtc(userId)
        window.neoRtc.socket.on('bc-message', (data) => {
            const chat = data.data
            pushChatNotifications(chat)
        })
    }

    
    await loadChatNotifications()
})
</script>

<template>
    <a href="#" class="dropdown-toggle nk-quick-nav-icon" data-bs-toggle="dropdown">
        <div :class="notifications.data.length ? 'icon-status icon-status-info' : ''">
            <em class="icon ni ni-chat-circle-fill"></em>
        </div>
    </a>
    <div class="dropdown-menu dropdown-menu-xl dropdown-menu-right dropdown-menu-s1">
        <div class="dropdown-head">
            <span class="sub-title nk-dropdown-title">My Connect <span class="badge rounded-pill bg-primary">{{ notifications.data.length }}</span></span>
            <a href="javascript:void(0)" @click="readAll()">Mark All as Read</a>
        </div>
        <div class="dropdown-body">
            <div class="nk-notification">

                <div class="nk-notification-item dropdown-inner" v-for="notification in notifications.data">
                    <div class="nk-notification-icon">
                        <em
                            class="icon icon-circle bg-warning-dim ni ni-curve-down-right"></em>
                    </div>
                    <div class="nk-notification-content">
                        <div class="nk-notification-text ccap">
                            {{notification.contact.full_name}}
                        </div>
                        <div class="nk-notification-time" v-html="notification.meta.content_type != 'text' ? (notification.document ? `<i>Sending ${notification.meta.content_type}</i>` : `<i>File has been deleted</i>`) : notification.meta.content"></div>
                    </div>
                </div>

            </div>
        </div>
        <div class="dropdown-foot center">
            <a href="/my-connect">Go to My Connect</a>
        </div>
    </div>
</template>

<style scoped>

</style>
